var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"creationModal",attrs:{"no-close-on-backdrop":true,"no-close-on-esc":true,"hide-footer":"","size":"lg"}},[_c('div',{staticClass:"d-block"},[_c('div',{staticClass:"titre-btn"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f594b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/creationModal.vue
// module id = null
// module chunks = 